import { safeNextPath } from '../../auth/postLoginRoute'

/**
 * A dónde vuelve el wizard de perfil (`KnowProfile`) al guardar, según su
 * `?next=`. El aviso de perfil incompleto del lobby del vr-app manda
 * `?next=/vr/`: esa ruta es otra app (no la resuelve react-router), así que
 * se navega con recarga. Cualquier otra ruta interna segura va por el router.
 * Sin `next` (o con uno inseguro) el wizard se queda mostrando el resumen.
 */
export type ProfileReturn = { path: string; reload: boolean } | null

export function profileReturnTarget(raw: string | null | undefined): ProfileReturn {
  const path = safeNextPath(raw)
  if (!path) return null
  return { path, reload: path === '/vr' || path.startsWith('/vr/') }
}
